export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/BlogIcon.56d04790.svg","height":21,"width":20};